import styled from "styled-components";

export const AnalysisContainer = styled.div`
  background: #fffff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: flex;
  position: relative;
`
export const FilterWrap = styled.div`
  display: flex;
  flex-direction: row;
  color: #f9f9f9;
  padding: 10px 0;
  background-size: 100% auto;
  align-items: center;
  justify-content: center;
  border-bottom-style: solid;
  border-bottom-width: thin;
  border-bottom-color: gray;
`;

export const Form = styled.form`
  background: #f9f9f9;
  max-width: 400px;
  height: auto;
  width: 100%;
  z-index: 1;
  display: grid;
  margin: auto auto;
  // padding: 5px 5px;
  // border-radius: 1px;
  // box-shadow: 0 1px 1px rgba(0, 0, 0, 0.9);

  @media screen and (max-width: 400px) {
    padding: 32px 32px;
  }
`;

export const FormInput = styled.input`
  padding: 16px 16px;
  border: none;
  border-radius: 4px;
`;

export const Card = styled.div`
  background-color: #fffff;
  height: 400px;
  border-radius: 5px;
  display: flex;
  margin-top: 30px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.7);
  color: white;
`;

export const FormH1 = styled.h1`
  margin-top: 30px;
  margin-bottom: 30px;
  color: #006ee6;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`;